import React from "react";
import missionBgTitle from "../../../../../assets/images/Event-2025/missions-title-bg.png";
import missionBgTitleDesktop from "../../../../../assets/images/Event-2025/missions-title-bg-desktop.png";
import missionBgTitleDesktopLeft from "../../../../../assets/images/Event-2025/missions-title-bg-desktop-left.png";
import missionBgTitleDesktopRight from "../../../../../assets/images/Event-2025/missions-title-bg-desktop-right.png";
import { mediaQueryPoint, useMediaQuery } from "../../../../../utils/hooks";
import "./index.scss";
import iconFooter from "../../../../../assets/images/Event-2025/icon-bg-footer.svg";
import { useTranslation } from "react-i18next";

function MissionsList({
  title = "Missions to earn attempts",
  children,
  hideFooter = false,
  hideFooterText = false,
  className,
}) {
  const isMobile = useMediaQuery(`(max-width: ${mediaQueryPoint.lg}px)`);
  const { t } = useTranslation();
  return (
    <div
      id="id-missions-list__event-2025"
      className={`missions-thingyan__bg ${className}`}
    >
      <div className="missions-list-container">
        <div
          className={`missions-list-title-wrapper ${isMobile ? "mobile" : ""}`}
        >
          {!isMobile ? (
            <>
              <img
                src={missionBgTitleDesktopLeft}
                alt=""
                className="mission-list-title-bg-desktop-left"
              />
              <img
                src={missionBgTitleDesktop}
                alt=""
                className="mission-list-title-bg-desktop"
              />
              <img
                src={missionBgTitleDesktopRight}
                alt=""
                className="mission-list-title-bg-desktop-right"
              />
            </>
          ) : (
            <img
              src={missionBgTitle}
              alt=""
              className="mission-list-title-bg"
            />
          )}

          <p className="missions-list-title">{title}</p>
        </div>
        <div className="missions-list">{children}</div>
      </div>
      {!hideFooter && (
        <div className="position-relative">
          {!hideFooterText && (
            <div
              className="super-title__thingyan"
              dangerouslySetInnerHTML={{
                __html: t("event_thingyan.collect_piece.footer"),
              }}
            ></div>
          )}
          <img src={iconFooter} alt="" className="thingyan-footer" />
        </div>
      )}
    </div>
  );
}

export default MissionsList;
